import StatisticsOnObjectsLightingIcon from './component'

export default StatisticsOnObjectsLightingIcon
